module.exports = __webpack_public_path__ + "img/cpxl—icon.3ea32028.png";